import { DraftReturnSchema } from "@redotech/redo-model/draft-return/draft-return";
import { zExt } from "@redotech/rpc/ext";
import { z } from "zod/v4";

export const skipAddReturnItems = {
  name: "skipAddReturnItems" as const,
  input: z.object({ draftReturnId: zExt.objectId() }),
  output: z.object({ draftReturn: DraftReturnSchema }),
};
